module.exports = {
	"id": "/tourn_round_starts",
	"type": "object",
	"properties": {
		"countryId": {
			"type": "integer",
			"required": true
		},
		"tournamentId": {
			"type": "integer",
			"required": true
		},
		"seasonId": {
			"type": "integer",
			"required": true
		},
		"sportId": {
			"type": "integer",
			"required": true
		},
		"round": {
			"type": "string",
			"required": true
		},
		"eventIds": {
			"required": true,
			"type": "array",
			"items": {
				"type": "integer"
			}
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ../src/config/message_schemas/triggers/tourn_round_starts.json
 ** module id = 1835
 ** module chunks = 0
 **/